module.exports = __webpack_public_path__ + "assets/bulleted_list-mobile.5a7a4c20.svg";